var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agentgrid-mark",attrs:{"role":"img","aria-label":"Agent Grid"}},_vm._l((_vm.cells),function(opacity,index){return _c('span',{key:index,staticClass:"agentgrid-mark-cell",style:({ opacity })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }